// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1vrQF","left":"styles_left__1KoVd"};